import { PinMark } from './PinMark';

type BrandMarkProps = {
  name: string;
  size?: 'normal' | 'large';
};

/** The pin next to the classroom's name, in the heading font. */
export function BrandMark({ name, size = 'normal' }: BrandMarkProps) {
  const large = size === 'large';
  return (
    <span
      className={`inline-flex items-center gap-2 font-extrabold ${large ? 'text-3xl' : 'text-xl'}`}
      style={{ fontFamily: 'var(--font-heading)' }}
    >
      <PinMark size={large ? 30 : 22} />
      {name}
    </span>
  );
}
